export enum StandardNetHttpProblemFieldKey {
  ClientOperator = 'standard_client_operator',
  ClientCountry = 'standard_client_country',
  ClientProvince = 'standard_client_province',
  ClientCity = 'standard_client_city',
  Host = 'standard_host',
  Path = 'standard_path',
  URL = 'standard_url',
  ResultCode = 'standard_result_code',
  Method = 'standard_method',
  StatusCode = 'standard_status_code',
  HostIp = 'standard_host_ip',
  HostCountry = 'standard_host_country',
  HostProvince = 'standard_host_province',
  HostCity = 'standard_host_city',
  HostOperator = 'standard_host_operator',
  TotalCostInMs = 'standard_total_cost_in_ms',
  DnsCostInMs = 'standard_dns_cost_in_ms',
  TcpCostInMs = 'standard_tcp_cost_in_ms',
  SslCostInMs = 'standard_ssl_cost_in_ms',
  RequestCostInMs = 'standard_request_cost_in_ms',
  WaitCostInMs = 'standard_wait_cost_in_ms',
  ResponseCostInMs = 'standard_response_cost_in_ms',
  RequestByteCount = 'standard_request_byte_count',
  ResponseByteCount = 'standard_response_byte_count'
}

export enum NetHttpProblemFieldKey {
  ClientOperator = 'client_operator',
  ClientCountry = 'client_country',
  ClientProvince = 'client_province',
  ClientCity = 'client_city',
  Host = 'host',
  Path = 'path',
  ResultCode = 'result_code',
  Method = 'method',
  StatusCode = 'status_code',
  HostIp = 'host_ip',
  HostCountry = 'host_country',
  HostProvince = 'host_province',
  HostCity = 'host_city',
  HostOperator = 'host_operator',
  TotalCostInMs = 'total_cost_in_ms',
  DnsCostInMs = 'dns_cost_in_ms',
  TcpCostInMs = 'tcp_cost_in_ms',
  SslCostInMs = 'ssl_cost_in_ms',
  RequestCostInMs = 'request_cost_in_ms',
  WaitCostInMs = 'wait_cost_in_ms',
  ResponseCostInMs = 'response_cost_in_ms',
  RequestByteCount = 'request_byte_count',
  ResponseByteCount = 'response_byte_count',
  URL = 'url',
}
